import './location-header-block.tpl.php';
import './style.scss';

jQuery($ => {
  $('.location-header-block__accordion-button').click(function() {
    $('.location-header-block__accordion-content').toggleClass('open');
    $('.icon-RCT-down').toggleClass('rotated');
  });
});
